export class ConeSide {
    constructor() {
        this.Removed = false;
    }
}
//# sourceMappingURL=ConeSide.js.map